module.exports = __webpack_public_path__ + "static/media/champagne_pop.aba7e69c.svg";